// The p10–p90 of sold Romanian flats, per type: 615 flats from 29
// developers (docs/REFERENCE-PLANS.md, from `scripts/plans-stats.ts` over
// the uncommitted records in .data/plans). Areas are net, as the developers
// publish them; frontage and depth in metres.
//
// These numbers are the standard a generated flat is held to. They are
// written here, not read from .data, because the records are the
// developers' material and stay out of the repository.

export interface Range { p10: number; med: number; p90: number }
export interface TypeReference {
  usable: Range;
  frontage: Range;
  depth: Range;
  living: Range;
  /** The living room with its open kitchen, and the living room beside a closed kitchen: two different rooms. */
  livingOpen: Range;
  livingClosed: Range;
  bedroom?: Range;
  bath: Range;
  hall: Range;
  baths: number;
}

const r = (p10: number, med: number, p90: number): Range => ({ p10, med, p90 });

export const REFERENCE: Record<string, TypeReference> = {
  "1": { usable: r(37, 41.5, 47.8), frontage: r(5.3, 6.6, 8.6), depth: r(6.2, 7.3, 8.8), living: r(18.8, 25.4, 33.9), livingOpen: r(20.4, 28.9, 35.3), livingClosed: r(18.3, 20, 27.6), bath: r(4.5, 4.7, 5.7), hall: r(2.2, 4.0, 6.3), baths: 1 },
  "2": { usable: r(44.6, 55, 64.2), frontage: r(7.2, 9.0, 11.5), depth: r(6.3, 7.8, 10), living: r(18.1, 22.4, 30.6), livingOpen: r(21.6, 28.9, 33.8), livingClosed: r(18, 19.4, 23.5), bedroom: r(12.2, 13.5, 16.6), bath: r(3.7, 4.6, 5.6), hall: r(2.7, 5.0, 7.9), baths: 1 },
  "3": { usable: r(66, 75.6, 87.3), frontage: r(10.3, 13.5, 18.3), depth: r(6.5, 7.8, 10.8), living: r(19.2, 23.8, 31.1), livingOpen: r(25.1, 28.9, 34.3), livingClosed: r(18.1, 21.4, 25.9), bedroom: r(12, 14, 17.4), bath: r(3.5, 4.4, 5.2), hall: r(3.6, 6.9, 12.1), baths: 2 },
  "4": { usable: r(87.5, 100.5, 135.8), frontage: r(15, 19, 24), depth: r(6.5, 8.2, 10), living: r(21.9, 28.1, 42), livingOpen: r(28.1, 34.5, 52.9), livingClosed: r(23.4, 26.7, 38.6), bedroom: r(12.1, 14, 19.3), bath: r(3.6, 4.5, 5.6), hall: r(4.7, 8.9, 15), baths: 2 },
};

/** Net room area from a wall-to-wall one: half of a 10–12.5 cm partition all round. */
export const ROOM_NET = 0.92;
